export default __webpack_public_path__ + "static/media/ultima-etapa.f00d4f5d.webp";